import { useEffect, useRef, useState } from 'react';
import { H1, H2, H3, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Select } from '../../../styles/GlobalComponents';

import { useAppSelector } from '../../../app/hooks';
import Spinner from '../../../components/common/Spinner';

const PaymentSaveAndTravel = ({
  selectedPackage
}: {
  selectedPackage: any;
}) => {
  const HOSTED_URL = 'https://payments.taylr.io/hosted/';

  const formRef = useRef<HTMLFormElement>(null);

  const { saveAndTravelSubscriptionPayload, addHubLoading } = useAppSelector(
    (state) => state.marketplace
  );

  useEffect(() => {
    if (formRef.current && (window as any).hostedForms) {
      new (window as any).hostedForms.classes.Form(formRef.current);
    }
  }, []);

  return (
    <>
      {addHubLoading ? (
        <Spinner />
      ) : (
        <div>
          <H2 center bold mb='40'>
            Complete Your Payment
          </H2>

          <div className='order-details'>
            <h3>Order Details</h3>
            <P2 mb='10' mt='10'>
              <strong>Amount: </strong>
              {saveAndTravelSubscriptionPayload?.payload?.amount} EUR
            </P2>
          </div>

          <form
            ref={formRef}
            method='post'
            action={HOSTED_URL}
            data-hostedform-modal>
            {saveAndTravelSubscriptionPayload?.payload &&
              Object.entries(saveAndTravelSubscriptionPayload?.payload).map(
                ([k, v]) => (
                  <input key={k} type='hidden' name={k} value={String(v)} />
                )
              )}

            <input
              type='hidden'
              name='signature'
              value={saveAndTravelSubscriptionPayload?.signature}
            />

            <Button mt={10} type='submit'>
              Pay Now
            </Button>
          </form>
        </div>
      )}
    </>
  );
};

export default PaymentSaveAndTravel;
